import { useSearchParams } from 'react-router-dom';

export function useMFATokenFromUrl() {
  const [params] = useSearchParams();

  const token = params.get('token') || '';
  let email = '';

  if (token) {
    email = getEmailFromMFAToken(token);
  }

  return { token, email, exp: getDateFromMFAToken(token) };
}

function getEmailFromMFAToken(token: string): string {
  const jwtContent = parseJWT(token) as { userEmail: string };

  return jwtContent?.userEmail || '';
}

function getDateFromMFAToken(token: string): number {
  const jwtContent = parseJWT(token) as { exp: number };

  return (jwtContent?.exp || 0) * 1000;
}

function parseJWT(token: string): unknown {
  const base64Url = token.split('.')[1];
  const base64 = base64Url?.replace(/-/g, '+').replace(/_/g, '/') || '';
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  return jsonPayload ? JSON.parse(jsonPayload) : {};
}
